import styled from 'styled-components';

export const StyledDeleteButtonWrapper = styled.div`
  display: flex;
  margin: ${({ theme }) => `0 ${theme.space[4]}px ${theme.space[4]}px`};
`;

export const StyledEditLocationContainer = styled.div`
  justify-content: center;
  width: 100%;
  position: relative;
  & > img {
    width: 100%;
  }
  & > button {
    position: absolute;
    top: 55%;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    z-index: 500;
    background-color: ${({ theme }) => `#ffffff80`};
    color: ${({ theme }) => theme.color.blueAccent};
    border-color: ${({ theme }) => theme.color.blueAccent};
  }
`;

export const StyledMapWrapper = styled.div`
  width: 100%;
  height: 15em;
`;
